
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.876 4.816h-.225l-.422 2.11h1.069l-.422-2.11z","fill":"#fff"}}),_c('path',{attrs:{"d":"M13.409 9.035c.228.612.53 1.108.864 1.53.334-.422.672-.918.9-1.53H13.41z","fill":"#000"}}),_c('path',{attrs:{"d":"M16.418 3.2h-6.55l1.364 10.957c.025.447-.098.872-.39 1.2L8.532 18h7.886C17.29 18 18 17.29 18 16.418V4.816c0-.871-.71-1.617-1.582-1.617z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.014 0c.798 0 1.473.594 1.571 1.385.007.056 1.603 12.878 1.603 12.934-.006.204-.104.313-.233.455l-.055.062H1.582C.71 14.836 0 14.126 0 13.254V1.582C0 .71.71 0 1.582 0h5.432zM5.843 9.664a.53.53 0 00.622.415.517.517 0 00.408-.622L5.818 4.184a.53.53 0 00-.516-.426h-1.09a.53.53 0 00-.517.426L2.64 9.457a.53.53 0 001.037.207l.338-1.684h1.49l.338 1.684z","fill":"#fff"}}),_c('path',{attrs:{"d":"M6.163 15.89l.091.725c.06.485.383.977.91 1.227 1-1.1.395-.436 1.773-1.948l-2.774-.003z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.459 7.611v.946h-.844v4.718h-1.199v-1.958h-.904v.06c0 .45-.154.815-.46 1.096-.306.282-.763.422-1.371.422a3.45 3.45 0 01-1.146-.186v-1.097c.358.19.724.288 1.09.288.495 0 .741-.235.741-.71a.551.551 0 00-.172-.429c-.116-.105-.323-.161-.63-.161h-.344v-.995h.26c.468 0 .7-.176.7-.524 0-.338-.197-.506-.59-.506-.289 0-.584.07-.886.21V7.714c.274-.105.6-.161.977-.161.541 0 .956.123 1.248.365.292.246.44.58.44 1.01 0 .29-.078.54-.23.751-.15.208-.368.352-.65.43.236.034.436.115.598.245h1.325V8.558h-.646v-.946h2.693z","fill":"#EE3A84"}})])
          )
        }
      }
    